/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rentals__disclaimers[_ngcontent-%COMP%]{font-size:13px;color:#666}  .mat-checkbox-checked .mat-checkbox-background{background-color:#75ba1d!important}  .mat-checkbox-ripple .mat-ripple-element{background-color:rgba(117,186,29,.26)!important}"];
export { styles as styles };
